type TRegExpsRaw = {
  beforeLinkTarget: string
  japanese: string
  emoji: string
  surrogatePair: string
  url: string
  nonAlphanumericUrl: string
  domainAt$1: string
  tillProtocol: string
  uniqueId: {
    twitter: string
    instagram: string
    facebook: string
    line: string
    tiktok: string
    '': string
  }
  hashtag: {
    twitter: string
    instagram: string
    facebook: string
    line: string
    tiktok: string
    '': string
  }
  allHashTag: string
  hashtagLike: string
  cr: string
  lf: string
  crlf: string
  accountPostPagePath: string
  accountPagePath: string
  accountListPagePath: string
  campaignPath: string
  dashboardPath: string
  redirect: string
  accountPath: string
}
/**
 * \u{30A0}-\u{30FF}: カタカナ
 * \u{30a0}-\u{30fa}\u{30fd}-\u{30ff} カタカナから「・」を除外
 * \u{3040}-\u{309F}: ひらがな
 * \u{4E00}-\u{9FAF}: 常用漢字（日本語で一般的に使われる漢字）
 * \u{3400}-\u{4DBF}: CJK統合漢字拡張A（追加漢字）
 * \u{F900}-\u{FAFF}: CJK互換漢字
 * \u{3000}-\u{303F}: CJKシンボルおよび句読点の範囲 (\u3005: 「々」, \u3006: 「〆」はここ)
 */
//const japanese = '\u{30a0}-\u{30ff}\u{3040}-\u{309f}\u{4e00}-\u{9faf}\u{3400}-\u{4dbf}\u{f900}-\u{faff}\u{3000}-\u{303f}'
const japanese = '\u{30a0}-\u{30fa}\u{30fd}-\u{30ff}\u{3040}-\u{309f}\u{4e00}-\u{9faf}\u{3400}-\u{4dbf}\u{f900}-\u{faff}\u{3000}-\u{303f}'

// 実際にinstagramで使用できる記号・絵文字のコードを網羅したもの
const flags = '🏁🚩🎌🏴🏳🏳️‍🌈🇦🇨-🇿🇼'
/**
 * utf-16ユニコードの組み合わせでないものだけ抽出
 * 男性・女性・肌の色の各組み合わせにmatchする
 *
 * cf.https://lets-emoji.com/emojilist/
 */
// eslint-disable-next-line max-len
const person = '\u{1F476}\u{1F9D2}\u{1F466}\u{1F467}\u{1F9D1}\u{1F471}\u{1F468}\u{1F9D4}\u{1F469}\u{1F9D3}\u{1F474}\u{1F475}\u{1F46E}\u{1F575}\u{1F482}\u{1F977}\u{1F477}\u{1F934}\u{1F478}\u{1F473}\u{1F472}\u{1F9D5}\u{1F935}\u{1F470}\u{1F930}\u{1F931}\u{1F936}\u{1F9B8}\u{1F9B9}\u{1F9D9}\u{1F9DA}\u{1F9DB}\u{1F9DC}\u{1F9DD}\u{1F9DE}\u{1F9DF}'
const gesture = '\u{1F64D}\u{1F64E}\u{1F645}\u{1F646}\u{1F481}\u{1F64B}\u{1F9CF}\u{1F647}\u{1F926}\u{1F937}'
const gender = '\u{2642}\u{2640}'
const skinColor = '\u{1F3FB}\u{1F3FC}\u{1F3FD}\u{1F3FE}\u{1F3FF}'
// eslint-disable-next-line max-len
const emoji = `\u{203c}\u{2049}\u{2122}\u{2139}\u{2194}-\u{2199}\u{21a9}\u{21aa}\u{231a}\u{231b}\u{2328}\u{2388}\u{23cf}\u{23e9}-\u{23f3}\u{23f8}-\u{23fa}\u{24c2}\u{25aa}\u{25ab}\u{25b6}\u{25c0}\u{25fb}-\u{25fe}\u{266a}\u{266d}\u{266f}\u{2605}\u{2606}\u{2640}\u{2642}\u{2648}-\u{2653}\u{2660}\u{2663}\u{2665}\u{2666}\u{2668}\u{267b}\u{267f}\u{2692}-\u{2694}\u{2696}\u{2697}\u{2699}\u{269b}\u{269c}\u{26a0}\u{26a1}\u{26aa}\u{26ab}\u{26b0}\u{26b1}\u{26bd}\u{26be}\u{26c4}\u{26c5}\u{26c8}\u{26ce}\u{26cf}\u{26d1}\u{26d3}\u{26d4}\u{26e9}\u{26ea}\u{26f0}-\u{26f5}\u{26f7}-\u{26fa}\u{26fd}\u{2702}\u{2705}\u{2708}-\u{270d}\u{270f}\u{2712}\u{2714}\u{2716}\u{271d}\u{2721}\u{2728}\u{2733}\u{2734}\u{2744}\u{2747}\u{274c}\u{274e}\u{2753}-\u{2755}\u{2757}\u{2763}\u{2764}\u{2795}-\u{2797}\u{27a1}\u{27b0}\u{27bf}\u{2934}\u{2935}\u{2b05}-\u{2b07}\u{2b1b}\u{2b1c}\u{2b50}\u{2b55}\u{1f004}\u{1f0cf}\u{1f170}\u{1f171}\u{1f17e}\u{1f17f}\u{1f18e}\u{1f191}-\u{1f19a}\u{1f201}\u{1f202}\u{1f21a}\u{1f22f}\u{1f232}-\u{1f23a}\u{1f250}\u{1f251}\u{1f300}-\u{1f321}\u{1f324}-\u{1f393}\u{1f396}\u{1f397}\u{1f399}-\u{1f39b}\u{1f39e}-\u{1f3f0}\u{1f3f3}-\u{1f3f5}\u{1f3f7}-\u{1f4fd}\u{1f4ff}-\u{1f53d}\u{1f549}-\u{1f54e}\u{1f550}-\u{1f567}\u{1f56f}\u{1f570}\u{1f573}-\u{1f579}\u{1f587}\u{1f58a}-\u{1f58d}\u{1f590}\u{1f595}\u{1f596}\u{1f5a5}\u{1f5a8}\u{1f5b1}\u{1f5b2}\u{1f5bc}\u{1f5c2}-\u{1f5c4}\u{1f5d1}-\u{1f5d3}\u{1f5dc}-\u{1f5de}\u{1f5e1}\u{1f5e3}\u{1f5ef}\u{1f5f3}\u{1f5fa}-\u{1f64f}\u{1f680}-\u{1f6c5}\u{1f6cb}-\u{1f6d0}\u{1f6e0}-\u{1f6e5}\u{1f6e9}\u{1f6eb}\u{1f6ec}\u{1f6f0}\u{1f6f3}\u{1F6F7}\u{1F7E0}-\u{1F7EB}\u{1f910}-\u{1f918}\u{1F92F}\u{1F970}-\u{1F97F}\u{1F93F}\u{1F942}-\u{1F94F}\u{1F950}-\u{1F96F}\u{1f980}-\u{1f984}\u{1f9c0}\u{1F9ED}\u{1F9F5}-\u{1F9F6}\u{1F97A}\u{1F9D0}\u{1FA80}-\u{1FA81}\u{1FAA1}-\u{1FAA2}\u{a9}\u{ae}\u{1F51F}\u{1F522}${flags}${person}${gesture}${gender}${skinColor}`

export const regExpsRaw: TRegExpsRaw = {
  beforeLinkTarget:
    // eslint-disable-next-line max-len
    // '(\\【|\\】|\\「|\\」|\\『|\\』|\\（|\\）|\\〈|\\〉|\\《|\\》|\\〔|\\〕|\\〘|\\〙|\\｛|\\｝|\\［|\\］|\\〚|\\〛|\\｟|\\｠|\\‘|\\’|\\“|\\”|\\〝|\\〟|\\＜|\\＞|\\<|\\>|\\[|\\]|\\"|\\"|\'|\'|\\▶|\\s){1}',
  　'(\\【|\\】|\\「|\\」|\\『|\\』|\\（|\\）|\\〈|\\〉|\\《|\\》|\\〔|\\〕|\\〘|\\〙|\\｛|\\｝|\\［|\\］|\\〚|\\〛|\\｟|\\｠|\\‘|\\’|\\“|\\”|\\〝|\\〟|\\＜|\\＞|\\<|\\>|\\[|\\]|\"|\'|\\▶| {2}|\\s)',

  japanese,
  emoji,
  surrogatePair: '[\uD800-\uDBFF][\uDC00-\uDFFF]',
  url: `(?<=^|\\W)(https?:\\/\\/[\\w!?\\/+\\-~=;.,*&@#$%()’\\[\\]:${japanese}]+)`,
  nonAlphanumericUrl: '(\\W+)(https?:\\/\\/\\S+)',
  domainAt$1: 'https?:\\/\\/([^\\/]+)',
  tillProtocol: 'https?:\\/\\/',
  // Twitter の uniqueId、記号では _ のみ含めることができる ref. https://help.twitter.com/ja/managing-your-account/twitter-username-rules
  uniqueId: {
    twitter: '@[0-9a-zA-Z_]',
    instagram: '@(?:[a-zA-Z0-9_]+(?:\\.?[a-zA-Z0-9_]+))',
    facebook: '@(?:[a-zA-Z0-9]+(?:\\.?[a-zA-Z0-9]+)*)',
    tiktok: '^[a-zA-Z0-9._]{1,100}$',
    line: '',
    '': ''
  },
  hashtag: {
    twitter: `[#＃][0-9a-zA-Z_${japanese}?!.*\#]`, // eslint-disable-line
    //instagram: `[#＃][Ａ-Ｚａ-ｚA-Za-z一-鿆0-9０-９ぁ-ヶー$%&_・${japanese}${emoji}]`,
    instagram: `[#＃][A-Za-z一-鿆0-9０-９ぁ-ヶー$_${japanese}${emoji}]`,
    // instagram: `[#＃][A-Za-z一-鿆0-9０-９ぁ-ヶー$_${emoji}]`,
    facebook: `[#＃][0-9a-zA-Z_${japanese}]`,
    tiktok: `[#][0-9a-zA-Z_${japanese}]`,
    line: '',
    '': ''
  },
  allHashTag: `[#＃][Ａ-Ｚａ-ｚA-Za-z一-鿆0-9０-９ぁ-ヶー$%&_・${japanese}${emoji}]`,
  // ハッシュタグっぽい文字列
  hashtagLike: '(?:#|＃|♯)[^\\s]*',
  cr: '\r',
  lf: '\n',
  crlf: '\r\n',
  accountPostPagePath: '^\\/brand\\/([0-9]+)\\/account\\/([0-9]+)\\/provider\\/([0-9a-zA-Z]+)\\/post\\/([0-9]+)',
  accountPagePath:
    // tiktokのmIdは数字アルファベット-の組み合わせ
    // eslint-disable-next-line max-len
    '^\\/brand\\/([0-9]+)\\/account\\/([0-9a-z-]+)\\/provider\\/([0-9a-zA-Z]+)\\/(posts|managed_posts|post|hashtags|stories|mentions|comments|analytics|complement|settings|rivals|tagged_posts|reels)',
  accountListPagePath: '^\\/brand\\/([0-9]+)\\/accounts',
  campaignPath: '^\\/brand\\/([0-9]+)\\/campaigns',
  dashboardPath: '^\\/brand\\/([0-9]+)',
  redirect: '^\\?redirect=',
  accountPath: ''
}
